import { render, staticRenderFns } from "./WidgetEditor.vue?vue&type=template&id=52c5ccde&scoped=true&"
import script from "./WidgetEditor.vue?vue&type=script&lang=js&"
export * from "./WidgetEditor.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEditor.vue?vue&type=style&index=0&id=52c5ccde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c5ccde",
  null
  
)

export default component.exports